import { render } from "./MonitorPanelView.vue?vue&type=template&id=5f5a35b2"
import script from "./MonitorPanelView.vue?vue&type=script&lang=js"
export * from "./MonitorPanelView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__